var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4965_29076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.3337C5.40964 18.3337 1.66797 14.592 1.66797 10.0003C1.66797 5.40866 5.40964 1.66699 10.0013 1.66699C14.593 1.66699 18.3346 5.03366 18.3346 9.16699C18.3346 11.9253 16.093 14.167 13.3346 14.167H11.8596C11.6263 14.167 11.443 14.3503 11.443 14.5837C11.443 14.6837 11.4846 14.7753 11.5513 14.8587C11.893 15.2503 12.0846 15.742 12.0846 16.2503C12.0846 17.4003 11.1513 18.3337 10.0013 18.3337V18.3337ZM10.0013 3.33366C6.3263 3.33366 3.33464 6.32533 3.33464 10.0003C3.33464 13.6753 6.3263 16.667 10.0013 16.667C10.2346 16.667 10.418 16.4837 10.418 16.2503C10.418 16.117 10.3513 16.017 10.3013 15.9587C9.95964 15.5753 9.7763 15.0837 9.7763 14.5837C9.7763 13.4337 10.7096 12.5003 11.8596 12.5003H13.3346C15.1763 12.5003 16.668 11.0087 16.668 9.16699C16.668 5.95033 13.6763 3.33366 10.0013 3.33366Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 10.833C6.10832 10.833 6.66797 10.2734 6.66797 9.58301C6.66797 8.89265 6.10832 8.33301 5.41797 8.33301C4.72761 8.33301 4.16797 8.89265 4.16797 9.58301C4.16797 10.2734 4.72761 10.833 5.41797 10.833Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91797 7.5C8.60833 7.5 9.16797 6.94036 9.16797 6.25C9.16797 5.55964 8.60833 5 7.91797 5C7.22761 5 6.66797 5.55964 6.66797 6.25C6.66797 6.94036 7.22761 7.5 7.91797 7.5Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.082 7.5C12.7724 7.5 13.332 6.94036 13.332 6.25C13.332 5.55964 12.7724 5 12.082 5C11.3917 5 10.832 5.55964 10.832 6.25C10.832 6.94036 11.3917 7.5 12.082 7.5Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.582 10.833C15.2724 10.833 15.832 10.2734 15.832 9.58301C15.832 8.89265 15.2724 8.33301 14.582 8.33301C13.8917 8.33301 13.332 8.89265 13.332 9.58301C13.332 10.2734 13.8917 10.833 14.582 10.833Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4965_29076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.880121b018687b3bc302324243696aad.svg";
export { ForwardRef as ReactComponent };